import { render, staticRenderFns } from "./ComprehensiveGovernance.vue?vue&type=template&id=23bbc2c4"
import script from "./ComprehensiveGovernance.vue?vue&type=script&lang=js"
export * from "./ComprehensiveGovernance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports